import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { IDay } from '@df/catalog/store/store';
import { ImageModule } from '@df/module-image/image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { HourFormat12Pipe } from '@df/ui/display/hour-format-12.pipe';
import { TranslationModule } from '@df/ui/translation/translation.module';
import sortBy from 'lodash-es/sortBy';
import { StoreOpenStatusComponent } from '../store-open-status/store-open-status.component';
import { LocalStore } from '../store.decorator';

declare module '@df/catalog/store/store' {
    interface IStoreDataV1 {
        images?: string[];
        tags?: { tag_id: number; tag_name: string }[];
    }
    interface Store {
        url?: string;
    }
}

export interface LocalTag {
    tag_id: number;
    tag_name: string;
    tag_icon: string;
}
@Component({
    selector: 'store-details',
    templateUrl: './store-details.html',
    styleUrls: ['./store-details.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ImageModule, HourFormat12Pipe, TranslationModule, HrefComponent, StoreOpenStatusComponent]
})
export class StoreDetailsComponent implements OnChanges {
    @Input()
    store?: LocalStore;
    weeklySchedule: IDay[] = [];
    isWarehouse?: boolean;
    ngOnChanges(): void {
        this.weeklySchedule = this.getWeeklySchedule();
        this.isWarehouse = this.store?.data?.url?.indexOf('warehouses') !== -1;
    }
    //returns 7 upcoming store opening days with details
    private getWeeklySchedule(): IDay[] {
        const openingHours = this.store?.openingHours;
        if (openingHours?.length) {
            const weeklySchedule = sortBy(openingHours.slice(0, 7), day => day.date && day.date.getDay());
            weeklySchedule[1] && weeklySchedule.push(weeklySchedule.shift() as IDay);
            return weeklySchedule;
        }
        return [];
    }

    asLocalTag(tag: { tag_id: number; tag_name: string }): { tag_id: number; tag_name: string; tag_icon: string } {
        return tag as LocalTag;
    }
}
